// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"e6-z","dimensionLabel":"f6-z","styleChooserControlWrapper":"g6-z","styleChooserControl":"h6-z","disabled":"i6-z","giftCard":"j6-z","styleChooserText":"k6-z"};